module.exports = __webpack_public_path__ + "img/03552d7.png";